export function getWindowSize(breakpointValue) {
  const breakpoint = breakpointValue;
  return $(globalThis).width() >= breakpoint;
}

export function headerSearchBarFix(searchPlaceholder) {
  const showMobileSearch = false;
  const mobileTrigger = getWindowSize(800);

  const $searchBox = $('.header .searchBox');
  $searchBox.find('.searchBoxSubmit .inputFieldSubmit').first().attr('tabindex', '-1');
  $searchBox.find('input').val('').attr('placeholder', searchPlaceholder);

  if (showMobileSearch) {
    $searchBox.addClass('mobile-enabled');

    if (!mobileTrigger) {
      $searchBox.attr('tabindex', '0');
    }
  }
}

export function updateContentMargin() {
  function applyMargin() {
    const headerHeight = $('header').outerHeight() || 0;

    const mq = globalThis.matchMedia('(max-width: 800px)');
    const additionalValue = mq.matches ? 0 : 50;

    const $content = $('.content');
    const $mainFeature = $('.mainSlideshow-autofeed-container');
    const isHomepage = $('body').hasClass('homepage');

    if (isHomepage) {
      $mainFeature.css('padding-top', `${headerHeight + additionalValue}px`);
    } else {
      $content.css('margin-top', `${headerHeight}px`);
    }
  }

  applyMargin();
  $(globalThis).on('resize scroll', applyMargin);
  new ResizeObserver(applyMargin).observe(document.querySelector('header'));
}

export function modifyFeatureLineup() {
  const $lineups = $('.featureLineupContainer');
  if (!$lineups.length) return;

  $lineups.each((_, el) => {
    const $lineup = $(el);
    const containerWidth = $lineup.width();
    const $buttonContainer = $lineup.find('.featureLineup-buttons.subContainer');
    const $icons = $buttonContainer.find('.featureLineup-social');
    const $cta = $buttonContainer.find('.featureLineup-buynow');

    if (!$icons.children().length) {
      $icons.remove();
      $buttonContainer.addClass('no-social');
      return;
    }

    const totalWidth = $icons.outerWidth(true) + $cta.outerWidth(true);

    if (totalWidth > containerWidth) {
      $buttonContainer.addClass('column');
    }
  });
}
